import {
  Accordion,
  Button,
  RadioButton,
} from "@axismaxlife/unified-ui-components-library";
import { Box, Container, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChildDetailsModal } from "../../commanComponents/ChildDetailsModal";
import {
  AddAnotherLink,
  DetailSummaryCard,
} from "../../commanComponents/DetailSummaryCard";
import { formatToIndianCurrency } from "../../logic/CurrencyFormatter";
import { AppToast } from "../../commanComponents/AppToast";
import { DependantDetailsModal } from "../../commanComponents/DependantDetailsModal";
import { JourneyProgressStepper } from "../../commanComponents/JourneyProgressStepper";
import { PageTitle } from "../../commanComponents/PageTitle";
import { ImageLibrary } from "../../constants/ImageLibrary";
import { String } from "../../constants/Strings";
import { AuthContext } from "../../Hooks/context/AuthContext";
import { useSavingGoals } from "../../api/apiEndpoints/SavingGoals";
import { DataContext } from "../../Hooks/context/ChildData";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { useLocalStorage } from "../../logic/LocalStorage/LocalStorage";
import { accordionSx } from "../../style/accordionSx";
import { colors } from "../../style/color/colors";
import { fonts } from "../../style/fonts/fonts";

const NoDetails = ({ addLabel, onAdd }) => (
  <Box sx={{ textAlign: "center", py: "16px" }}>
    <Box
      component="img"
      src={ImageLibrary.QUESTION_MARK}
      alt=""
      aria-hidden="true"
      sx={{ display: "block", mx: "auto", width: "120px", height: "auto" }}
    />
    <Typography
      sx={{
        mt: "16px",
        fontSize: "16px",
        fontFamily: fonts.notoSans,
        fontWeight: 400,
        color: colors.PrimaryWoodSmoke,
      }}
    >
      {String.ChildPlannig.noDetailsFound}
    </Typography>
    <Button
      buttonType="neutralLink"
      onClick={onAdd}
      iconLeft={
        <Box
          component="img"
          src={ImageLibrary.PLUS}
          alt=""
          aria-hidden="true"
          sx={{ display: "block", width: "16px", height: "auto" }}
        />
      }
    >
      {addLabel}
    </Button>
  </Box>
);

const ChildQuestion = () => {
  const location = useLocation();
  const { collectData, collectedData } = useContext(DataContext);

  const hasChildGoal = Boolean(
    location.state?.hasChildGoal ??
    collectedData?.hasChildGoal ??
    collectedData?.selectedGoals?.includes(2),
  );

  const [childCards, setChildCards] = useState([]);
  const [hasChildren, setHasChildren] = useState(
    hasChildGoal ? String.Yes : "",
  );
  const [isDependantCard, setIsDependantCard] = useState(false);
  const [addQuestionCard, setAddQuestionCard] = useState([]);
  const [children, setChildren] = useState([]);
  const [isChildModalOpen, setIsChildModalOpen] = useState(false);
  const [isDependantModalOpen, setIsDependantModalOpen] = useState(false);
  const [editingChildIndex, setEditingChildIndex] = useState(null);
  const [editingDependantIndex, setEditingDependantIndex] = useState(null);
  const [dependants, setDependants] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { saveGoals } = useSavingGoals();
  const navigation = useNavigate();
  const { userId } = authTokens;

  const handleSelectHasChildren = (val) => {
    setHasChildren(val);
    if (val === String.No) {
      setChildren([]);
      setChildCards([]);
    }
  };

  useEffect(() => {
    if (hasChildGoal) {
      setHasChildren(String.Yes);
    }
  }, [hasChildGoal]);

  useEffect(() => {
    const retrieveSavedData = async () => {
      try {
        const data = await retrieveLocalFinancialData(`childnameage-${userId}`);
        if (data) {
          if (data.childCards && hasChildGoal) {
            const countArray = Array.from(
              { length: data.childCards },
              (_, i) => i,
            );
            setChildCards(countArray);
          }

          if (data.children && Array.isArray(data.children) && hasChildGoal) {
            setChildren(data.children);
          } else {
            setChildren([]);
          }

          if (hasChildGoal) {
            setHasChildren(String.Yes);
          }

          if (
            data.dependants &&
            Array.isArray(data.dependants) &&
            data.dependants.length > 0
          ) {
            setDependants(data.dependants);
            setIsDependantCard(true);
            const dependantCards = Array.from(
              { length: data.dependants.length },
              (_, i) => i,
            );
            setAddQuestionCard(dependantCards);
          } else {
          }
        }
      } catch (error) { }
    };

    retrieveSavedData();
  }, []);

  const handleAddChildCard = () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioChildren,
      verifyData.customerId,
    );
    setEditingChildIndex(null);
    setIsChildModalOpen(true);
  };

  const handleAddDependantCard = () => {
    setEditingDependantIndex(null);
    setIsDependantModalOpen(true);
  };

  const handleEditChild = (index) => {
    setEditingChildIndex(index);
    setIsChildModalOpen(true);
  };

  const handleEditDependant = (index) => {
    setEditingDependantIndex(index);
    setIsDependantModalOpen(true);
  };

  const handleRemoveChildCard = (index) => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioChildren,
      verifyData.customerId,
    );
    if (childCards.length >= 1) {
      setChildCards(childCards.slice(0, -1));
    }
    setChildren(children.filter((_, i) => i !== index));
  };
  const handleSaveChild = (child) => {
    if (editingChildIndex === null) {
      setChildren((prev) => [...prev, child]);
      setChildCards((prev) => [...prev, prev.length]);
      return;
    }
    setChildren((prev) =>
      prev.map((item, index) => (index === editingChildIndex ? child : item)),
    );
  };

  const handleSaveDependant = (dependant) => {
    if (editingDependantIndex === null) {
      setDependants((prev) => [...prev, dependant]);
      setAddQuestionCard((prev) => [...prev, prev.length]);
      setIsDependantCard(true);
      return;
    }
    setDependants((prev) =>
      prev.map((item, index) =>
        index === editingDependantIndex ? dependant : item,
      ),
    );
  };
  const handleRemoveDependantCard = (index) => {
    setAddQuestionCard(addQuestionCard.filter((_, i) => i !== index));
    setDependants(dependants.filter((_, i) => i !== index));
  };

  const handleContinue = async () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioChildrenContinue,
      verifyData.customerId,
    );
    const activeChildren =
      !hasChildGoal && hasChildren === String.No ? [] : children;
    const activeChildCards =
      !hasChildGoal && hasChildren === String.No ? 0 : childCards.length;

    const allChildrenFilled = activeChildren.every(
      (child) => child.name.trim() !== "" && child.age !== "",
    );
    const allDependantsFilled = isDependantCard
      ? dependants.every(
        (dependant) => dependant.name.trim() !== "" && dependant.age !== "",
      )
      : true;

    if (!allChildrenFilled || !allDependantsFilled) {
      setSnackbarMessage(
        String.ChildPlannig.validationMessageforchildanddependant,
      );
      setSnackbarOpen(true);
      return;
    }

    let finalData;

    if (
      !dependants.every((dependant) =>
        Object.values(dependant).every((val) => val !== ""),
      )
    ) {
      finalData = {
        children: activeChildren,
        dependants: [],
        childCards: activeChildCards,
      };
    } else {
      finalData = {
        children: activeChildren,
        dependants: dependants,
        childCards: activeChildCards,
      };
    }
    saveLocalFinancialData(`childnameage-${userId}`, finalData);

    const selectedGoals = collectedData.selectedGoals || [];
    const isParentValue = hasChildGoal || hasChildren === String.Yes;
    const goalData = {
      userId: userId,
      isParent: isParentValue,
      futureGoalName: "",
      requiredAmount: "",
      targetYear: "",
      idealRetirement: "",
      children: finalData.children.map((child) => ({
        ...child,
        dreamCourseAmount: 0,
        courseName: child.courseName || "",
        educationCostEstimate: child.rangeOfCourse,
        weddingCostEstimate: child.weddingBudget,
        educationTargetYear: child.educationYear,
        weddingTargetYear: child.weddingYear,
      })),
      dependants: finalData.dependants,
      goals: [...selectedGoals],
    };

    collectData({ ...finalData, ...goalData });

    const shouldCallSaveApi =
      selectedGoals.length === 1 ||
      (selectedGoals.includes(1) &&
        selectedGoals.includes(2) &&
        !selectedGoals.includes(5) &&
        !selectedGoals.includes(4));

    if (!shouldCallSaveApi) {
      navigation(
        selectedGoals.includes(4)
          ? String.navigations.investmentgoal
          : String.navigations.retirementgoal,
      );
      return;
    }

    try {
      const response = await saveGoals(goalData);
      if (response.httpCode === 200) {
        navigation(String.navigations.fetchinfo);
      } else {
        setSnackbarMessage(String.errorMessageforGoalsave);
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage(String.errorMessageforGoalsave);
      setSnackbarOpen(true);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
      }}
    >
      <Container sx={{ flexGrow: 1, pb: "16px" }}>
        <PageTitle />
        <JourneyProgressStepper />
        {!hasChildGoal && (
          <Box sx={{ mt: "24px" }}>
            <Typography
              sx={{
                color: colors.NeutralDark700,
                fontSize: "16px",
                fontFamily: fonts.notoSans,
                fontWeight: 500,
              }}
            >
              {String.ChildPlannig.childrenQuestion}
            </Typography>
            <Stack
              direction="row"
              spacing="16px"
              sx={{ mt: "12px", height: "56px", width: "242px" }}
            >
              {[String.Yes, String.No].map((answer) => {
                const isSelected = hasChildren === answer;
                return (
                  <Box
                    key={answer}
                    onClick={() => handleSelectHasChildren(answer)}
                    sx={{
                      flex: 1,
                      p: "16px",
                      cursor: "pointer",
                      borderRadius: "8px",
                      border: `1px solid ${isSelected
                        ? colors.SecondarySummerSky
                        : colors.NeutralLightN80
                        }`,
                      backgroundColor: isSelected
                        ? colors.ExtendedPalettesSummerSkySS100
                        : colors.PrimaryWhite,
                    }}
                  >
                    <RadioButton
                      name="hasChildren"
                      value={answer}
                      label={answer}
                      checked={isSelected}
                      onChange={handleSelectHasChildren}
                    />
                  </Box>
                );
              })}
            </Stack>
          </Box>
        )}

        {(hasChildGoal || hasChildren === String.Yes) && (
          <Box
            sx={{
              mt: "16px",
              borderRadius: "16px",
              borderWidth: "1px",
              borderColor: colors.softGray,
              borderStyle: "solid",
              overflow: "hidden",
              "& .accordion-title": {
                color: colors.ColorpalettePrimaryMidnight,
              },
              "& .accordion-header": {
                borderBottom: `1px solid ${colors.softGray}`,
              },
              ...accordionSx,
            }}
          >
            <Accordion
              width="100%"
              defaultOpenIndex={0}
              items={[
                {
                  title: (
                    <Typography
                      component="span"
                      sx={{
                        color: colors.ColorpalettePrimaryMidnight,
                        fontSize: "18px",
                        fontWeight: 500,
                        fontFamily: fonts.notoSans,
                      }}
                    >
                      {String.ChildPlannig.childDetails}
                    </Typography>
                  ),
                  children:
                    childCards.length === 0 ? (
                      <NoDetails
                        addLabel={String.ChildPlannig.addChild}
                        onAdd={handleAddChildCard}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          pb: "16px",
                        }}
                      >
                        {children.map((child, index) => (
                          <DetailSummaryCard
                            key={index}
                            title={`${child.name}, ${child.age}${String.ChildPlannig.yearsSuffix}`}
                            rows={[
                              {
                                leftLabel: String.ChildPlannig.educationCost,
                                leftValue: formatToIndianCurrency(
                                  child.rangeOfCourse,
                                ),
                                rightLabel: String.ChildPlannig.fundsNeededBy,
                                rightValue: `${child.educationYear} ${String.ChildPlannig.yearsSuffix}`,
                              },
                              {
                                leftLabel: String.ChildPlannig.weddingCost,
                                leftValue: formatToIndianCurrency(
                                  child.weddingBudget,
                                ),
                                rightLabel: String.ChildPlannig.fundsNeededBy,
                                rightValue: `${child.weddingYear} ${String.ChildPlannig.yearsSuffix}`,
                              },
                            ]}
                            onEdit={() => handleEditChild(index)}
                            onDelete={() => handleRemoveChildCard(index)}
                          />
                        ))}
                        <AddAnotherLink
                          label={String.ChildPlannig.addAnotherChild}
                          onClick={handleAddChildCard}
                        />
                      </Box>
                    ),
                },
              ]}
            />
          </Box>
        )}

        <Box
          sx={{
            mt: "16px",
            borderRadius: "16px",
            borderWidth: "1px",
            borderColor: colors.softGray,
            borderStyle: "solid",
            overflow: "hidden",
            ...accordionSx,
          }}
        >
          <Accordion
            width="100%"
            defaultOpenIndex={-1}
            items={[
              {
                title: <Typography
                  component="span"
                  sx={{
                    color: colors.ColorpalettePrimaryMidnight,
                    fontSize: "18px",
                    fontWeight: 500,
                    fontFamily: fonts.notoSans,
                  }}
                >
                  {String.ChildPlannig.dependentsDetails}
                </Typography>,
                children:
                  !isDependantCard || addQuestionCard.length === 0 ? (
                    <NoDetails
                      addLabel={String.ChildPlannig.addDependant}
                      onAdd={handleAddDependantCard}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        pb: "16px",
                      }}
                    >
                      {dependants.map((dependant, index) => (
                        <DetailSummaryCard
                          key={index}
                          title={`${dependant.name}, ${dependant.age}${String.ChildPlannig.yearsSuffix}`}
                          onEdit={() => handleEditDependant(index)}
                          onDelete={() => handleRemoveDependantCard(index)}
                        />
                      ))}
                      <AddAnotherLink
                        label={String.ChildPlannig.addAnotherDependant}
                        onClick={handleAddDependantCard}
                      />
                    </Box>
                  ),
              },
            ]}
          />
        </Box>

        <Box sx={{ mt: "40px", mb: "40px" }}>
          <Button
            buttonType="primary"
            width="100%"
            disabled={
              hasChildGoal
                ? children.length === 0
                : hasChildren === "" ||
                (hasChildren === String.Yes && children.length === 0)
            }
            onClick={handleContinue}
          >
            {String.continue}
          </Button>
        </Box>
      </Container>
      <ChildDetailsModal
        isOpen={isChildModalOpen}
        onClose={() => setIsChildModalOpen(false)}
        onSave={handleSaveChild}
        initialValue={
          editingChildIndex === null ? null : children[editingChildIndex]
        }
      />
      <DependantDetailsModal
        isOpen={isDependantModalOpen}
        onClose={() => setIsDependantModalOpen(false)}
        onSave={handleSaveDependant}
        initialValue={
          editingDependantIndex === null
            ? null
            : dependants[editingDependantIndex]
        }
      />
      <AppToast
        open={snackbarOpen}
        message={snackbarMessage}
        severity={String.ErrorSeverity}
        handleClose={() => setSnackbarOpen(false)}
      />
    </Box>
  );
};

export default ChildQuestion;
